<template>
  <div class="videoplaym">
    <div class="backbox">
      <img
        class="back"
        @click="back()"
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAmCAYAAAAr+dCVAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADmSURBVHgB7dZLDoIwEAbggYlCWJn0Eh4HTqA380pyAnWnK9npwjBOSSDKQ9vOLPsnEDqEL00XwwAoBHOzT9fmnmbmBGtTJiCMBYngMBQImhQEmYDWTKgJ3ukcaNMSVBCS7gwzQ+MLcrODkEQwghGM4GJst1YFrcmdegPKQVoVN+7U5WfRrrl+htejhoAgf3hk4KIJY3dXhnF4UoTxa6UE46SiAONsVQjj4hsBvIwK4N9oIPwfDYDdUE/YHfWA/VBH2B91gGWTtP1rjGdUnqTDdtpnZsc8SV9laA9jUUNCWz6AJ7VYvQG/Zxt2ad0fUQAAAABJRU5ErkJggg=="
        alt=""
      />
    </div>
    <div class="header-wrap"  v-if="video.status == 2">
      <div class="title">
        <i class="el-icon-success"></i>
        <span>作品已生成</span>
      </div>
    </div>
    <div class="header-wrap"  v-if="video.status == 1 || video.status == 0">
      <div class="title">
        <i class="el-icon-loading"></i>
        <span>作品生成中</span>
       <p style="font-size: 14px;margin-top: 5px;color: gray;">返回不影响生成进度，稍后可在"创作历史"里查看</p>
      </div>
    </div>
    <div class="header-wrap"  v-if="video.status == 3">
      <div class="title">
        <i class="el-icon-error"></i>
        <span>作品生成失败</span>
      </div>
    </div>
    <div v-if="video.video_url != ''" class="videobox">
      <video
        :src="video.video_url"
        controls
        controlslist="nodownload noremoteplayback noplaybackrate"
        disablepictureinpicture
      ></video>
    </div>
  </div>
</template>

<script>
var time
import {videoQuery} from "@/api/video"
export default {
  data() {
    return {
      videoid:1,
      show: false,
      show2:false,
      video: {
        video_url: "",
		status:1,
      },
    };
  },
  mounted() {
    this.videoid = this.$route.query.id;
	if (this.videoid == null || this.videoid == undefined) {
		  this.videoid = this.$route.params.id;
	}
	videoQuery({id:this.videoid}).then(res=>{
	  this.video = res.data.video
	  if(this.video.status != 2 && this.video.status != 3){
	    this.videoQuery()
	  }
	})
  },
  methods: {
    back() {
      clearInterval(time)
      this.$router.back();
    },
    videoQuery(){
      time = setInterval(()=>{
        videoQuery({id:this.videoid}).then(res=>{
          this.video = res.data.video
          if(this.video.status == 2 || this.video.status == 3){
            clearInterval(time)
          }
        })
      },2000)
    },
  },
};
</script>

<style lang="less">
.videoplaym {
  .backbox {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    .back {
      height: 18px;
    }
  }
  .header-wrap {
    text-align: center;
    padding-top: 20px;
    i {
      color: #38b865;
    }
    .title {
      font-size: 22px;
      font-weight: 700;
      margin-bottom: 10px;
    }
    .text-gray {
      color: #999;
      font-size: 14px;
    }
  }
  .videobox {
    overflow: hidden;
    border-radius: 8px;
    background-color: #f4f5f7;
    margin: 20px 32px 0;
    box-sizing: border-box;
    video {
      width: 100%;
      display: block;
    }
  }
  .videotitle {
    font-size: 14px;
    color: #333;
    text-align: center;
    padding: 24px 0;
  }
  .audio-wrap {
    padding: 20px 16px;
    margin: 0 32px 36px;
    color: #333;
    background-color: #f4f5f7;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .copy {
      width: 52px;
      // height: 40px;
      border-left: 1px solid #e6e9ed;
      flex-shrink: 0;
      font-size: 20px;
      text-align: center;
    }
  }
  .tips-btn {
    margin-bottom: 24px;
    color: #666;
    font-size: 14px;
    text-align: center;
  }
  .btn-wrap {
    display: flex;
    justify-content: center;
    .el-button {
      width: 150px;
    }
  }
  .drawer-content {
    .drawer-head {
      font-weight: 700;
      font-size: 20px;
      color: #333;
      padding: 20px 32px 0;
    }
    .container {
      margin: 8px 32px 24px;
      color: #666;
      font-size: 12px;
    }
    .btn-wrap {
      padding: 0 32px;
      .el-button {
        height: 48px;
        border-radius: 8px;
        margin-bottom: 16px;
        font-size: 14px;
        width: 100%;
      }
    }
  }
  .imgbox {
    position: fixed;
    top: 40px;
    left: 50%;
    width: 300px;
    height: 400px;
    transform: translateX(-50%);
    border-radius: 8px;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .container-drawer{
    padding: 20px 32px;
    .header{
        margin-bottom: 12px;
        font-size: 20px;
        font-weight: 700;
        color: #333;
    }
    .text-error {
        color: #ff5556;
        font-weight: 700;
        font-size: 14px;
    }
    .text{
        margin-bottom: 12px;
        color: #666;
        font-size: 14px;
    }
    .btn-wrap{
        margin-top: 20px;
    }
  }
}
</style>